/**
 * Level 5: Volcano
 * 
 * Introduces lava hazards:
 * - Deadly lava zones (instant death)
 * - Tight platforming over hazards
 * - Magnetic box mechanics
 * - Intense red/orange atmosphere
 * 
 * @module configs/levels/Level05_Volcano
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level05_Volcano = {
    id: 5,
    name: 'Volcano',
    subtitle: 'The Floor is Lava',
    description: 'Navigate deadly lava with precision and magnetic skills.',
    
    worldWidth: 4000,
    worldHeight: 1400,
    playerStart: { x: 100, y: 1100 },
    
    theme: {
        bgGradient: ['#330000', '#ff4500'],
        platformColor: 0x3d2817,
        accentColor: 0xff4500,
        particleColor: 0xff6600
    },
    
    platforms: [
        { x: 0, y: 1200, w: 400, h: 50 },
        { x: 600, y: 1100, w: 150, h: 20 },
        { x: 900, y: 1000, w: 150, h: 20 },
        { x: 1300, y: 1100, w: 150, h: 20 },
        { x: 1600, y: 1000, w: 150, h: 20 },
        { x: 2000, y: 1200, w: 400, h: 50 },
        { x: 2450, y: 1050, w: 150, h: 20 },
        { x: 2800, y: 900, w: 100, h: 20 },
        { x: 3100, y: 1000, w: 100, h: 20 },
        { x: 3500, y: 1200, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 400, y: 1150, w: 100, h: 20, moveX: 100, speed: 0.005 },
        { x: 1100, y: 1050, w: 100, h: 20, moveY: 100, speed: 0.008 }
    ],
    
    spikes: [
        { x: 2100, y: 1200 },
        { x: 2150, y: 1200 },
        { x: 2200, y: 1200 },
        { x: 3600, y: 1200 },
        { x: 3650, y: 1200 },
        { x: 3700, y: 1200 }
    ],
    
    stars: [
        { x: 600, y: 1050 },
        { x: 1300, y: 1050 },
        { x: 2800, y: 850 },
        { x: 3800, y: 1150 }
    ],
    
    enemies: [
        { x: 2050, y: 1150 },
        { x: 2300, y: 1150 },
        { x: 3550, y: 1150 }
    ],
    
    door: { x: 3900, y: 1050, w: 50, h: 300 },
    button: { x: 3550, y: 1195 },
    box: { x: 2525, y: 1000, floating: true }, // MAGNETIC BOX
    goal: { x: 3950, y: 1100 },
    
    lavaZones: [
        { x: 1000, y: 1350, w: 800, h: 50 }
    ],
    
    speedrunTargets: { gold: 40, silver: 55, bronze: 75 }
};

export default Level05_Volcano;
